import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LoadingService {
  constructor() {}

  isLoading = new BehaviorSubject<boolean>(false);

  getLoader() {
    return this.isLoading;
  }

  startLoader() {
    this.isLoading.next(true);
  }

  stopLoader() {
    this.isLoading.next(false);
  }
}
